export default __webpack_public_path__ + "static/media/flavor_color_crop.2c4c4d77.png";